"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 9V7.487c0-.743-.22-1.469-.632-2.086l-.066-.098a5.17 5.17 0 0 0-8.606 0l-.066.098a3.76 3.76 0 0 0-.632 2.086V9H5.411a1.5 1.5 0 0 0-1.494 1.364l-.818 9A1.5 1.5 0 0 0 4.593 21h14.81a1.5 1.5 0 0 0 1.494-1.636l-.818-9A1.5 1.5 0 0 0 18.585 9zm-5-5c1.395 0 2.697.697 3.471 1.857l.066.098c.302.454.464.987.464 1.532V9h-8V7.487c0-.545.161-1.078.464-1.532l.066-.098A4.17 4.17 0 0 1 12.002 4zm-6.587 6h13.174a.5.5 0 0 1 .498.455l.818 9a.5.5 0 0 1-.498.545H4.595a.5.5 0 0 1-.498-.545l.818-9A.5.5 0 0 1 5.413 10"
}), 'MiniBag');
//# sourceMappingURL=index.js.map